<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新建胎号记录</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard"> 
            <ly-product-table 
                ref="productTable"
                :thead-config="productConfig">
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
    </div>
</template>
<script>
    /**
     * 胎号的新增页面
     * @author zjs
     * @time 2017-09-18
     */
    import AddProductConfig from './add-product'
    import LyProductTable from '@c/product-table'
    import LyRouterButton from '@c/router-button'
    import AddRulesConfig from './rules'
    export default {
        mixins: [
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LyProductTable,
            LyRouterButton
        },
        data () {
            return {                
                submitLoad: false // 提交按钮的状态标识
            }
        },
        watch: {
            '$route' (to, from) {
                // 清空之前的输入
                if (to.name === 'ChecktaiAdd') {
                    this.$refs['productTable'].resetList()
                }
            }
        },
        methods: {
            submit () {
                let productList = this.$refs['productTable'].getProductData()
                if (productList && productList.length > 0) {
                    // 货品验证
                    let productMsg = this.validateProduct(productList)
                    // 货品验证不通过的情况
                    if (productMsg.length > 0) {
                        this.$alert(productMsg, '货品录入提示', {
                            confirmButtonText: '确定'
                        })
                    } else {
                        this.submitLoad = true
                        // 提交数据
                        this.$api.create('api/taihaoGL',productList).then((rs) => {
                            this.$alert('数据提交成功', '新增', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.submitLoad = false
                                    // 跳转到详情页面
                                    this.$router.push('/bill/checktai/list')
                                }
                            });
                        }).catch((error) => {
                            this.submitLoad = false
                            this.$message({
                                message: error,
                                type: 'warning'
                            })
                        })
                    }
                } else {
                    this.$message({
                        message: '请选择货品',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>